/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Sub_Dashboard_Downgrade_ScheduledInputs */



/**
* | output |
* | --- |
* | "Downgrade to Starter scheduled for {date}." |
*
* @param {Sub_Dashboard_Downgrade_ScheduledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_dashboard_downgrade_scheduled = /** @type {((inputs: Sub_Dashboard_Downgrade_ScheduledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Dashboard_Downgrade_ScheduledInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Downgrade auf Starter geplant für ${i?.date}.`)
	return /** @type {LocalizedString} */ (`Downgrade to Starter scheduled for ${i?.date}.`)
});